// extracted by mini-css-extract-plugin
export default {"toolbarShadow":"style_toolbarShadow__EzuR2","topbar-buttons":"style_topbar-buttons__t04zP","button-wrapper":"style_button-wrapper__NEoS5","birdLogo":"style_birdLogo__gPblI"};